import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { QuotationData } from '../../models/quotations/Quotations';

export const QUOTES_URL = '/api/v1/offers';

const useQuotationSWR = (quoteId: string) => {
    const fetch = (query): Promise<QuotationData> => {
        return httpApi
            .get<{ offer: QuotationData }>(query)
            .then((res) => {
                return res.getData().offer;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        QUOTES_URL + '/' + quoteId,
        fetch,
        {
            // dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
            // revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        }
    );

    return {
        quote: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useQuotationSWR;
